import * as angular from 'angular';

angular.module('app').filter('filterParameterString', filterParameter);

function filterParameter(facetQueryService) {
	return function (filters) {
		return filters && filters.length ? filters.map(facetQueryService.formatFilter).join(',') : null;
	};
}
